var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',_vm._l((_vm.lottery.packages),function(cPackage){return _c('package-card',{key:cPackage.id,attrs:{"cPackage":cPackage},on:{"selected":_vm.onSelected}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }